// extracted by mini-css-extract-plugin
module.exports = {"root":"CornerRadius_root__P_5iQ","sharp":"CornerRadius_sharp__apL_d","s":"CornerRadius_s__lntfX","base":"CornerRadius_base__mUbaG","l":"CornerRadius_l__tsChq"};